import type { ObjectData, InterstellarObject } from './types'

const BASE = '/tracker/api'

export const api = {
  async interstellar(): Promise<InterstellarObject[]> {
    const res = await fetch(`${BASE}/interstellar.php`, { cache: 'no-store' })
    if (!res.ok) throw new Error(`interstellar failed: ${res.status}`)
    return res.json()
  },
  async object(id: string): Promise<ObjectData> {
    const res = await fetch(`${BASE}/object.php?id=${encodeURIComponent(id)}`, {
      cache: 'no-store',
    })
    if (!res.ok) {
      const text = await res.text().catch(() => '')
      throw new Error(`object failed: ${res.status} ${text?.slice(0, 120)}`)
    }
    return res.json()
  },
  async planets(
    jd?: number,
  ): Promise<
    Record<
      string,
      {
        a: number
        e: number
        i: number
        omega: number
        w: number
        M: number
        epoch_jd: number
        q?: number | null
      }
    >
  > {
    const url = `${BASE}/planets.php${jd ? `?jd=${encodeURIComponent(jd)}` : ''}`
    const res = await fetch(url, { cache: 'no-store' })
    try {
      const data = await res.json()
      return (data && (data as any).data) ? (data as any).data : data
    } catch {
      return {}
    }
  },
  async closest(): Promise<
    {
      items: Array<{
        id: string
        name: string
        date?: string
        dist_au?: number
        dist_ld?: number
        v_rel_kms?: number
      }>
    }
  > {
    const res = await fetch(`${BASE}/closest.php`, { cache: 'no-store' })
    if (!res.ok) throw new Error(`closest failed: ${res.status}`)
    return res.json()
  },
  async horizonsVectors(id: string): Promise<
    {
      id: string
      time: string
      helio?: { r_au?: number; vx_kms?: number | null }
      geo?: { delta_au?: number; delta_ld?: number; rr_kms?: number | null }
      error?: string
    }
  > {
    const res = await fetch(`${BASE}/horizons_vectors.php?id=${encodeURIComponent(id)}`, {
      cache: 'no-store',
    })
    if (!res.ok) throw new Error(`horizons vectors failed: ${res.status}`)
    return res.json()
  },
}
